// Detects iPhone / iPad / iPod. Used to show the iCloud-import reassurance note
// only to iOS users — they hit the "votre iPhone exporte les images" delay when
// importing large albums from iCloud (the native picker can take ~a minute).
// Android + desktop never see it.
export function isIOS(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/.test(ua)) return true;
  // iPadOS 13+ reports a desktop "Macintosh" UA — disambiguate via touch points
  // (a real Mac has 0; an iPad reports >1).
  if (/Macintosh/.test(ua) && (navigator.maxTouchPoints ?? 0) > 1) return true;
  return false;
}
